import React from "react";
import map from "../../../images/map.png";
import { contactsData, mapsData } from "../../../data/ContactData";
import Newsletter from "../../shared/Newsletter";
import Footer from "../../shared/Footer";
const Contact = () => {
  return (
    <>
      <div className=" py-10">
        <div className="space-y-5 justify-center flex flex-col items-center px-10">
          <p className="text-sm text-primary font-semibold">Contact us</p>
          <h3 className="lg:text-4xl md:text-3xl text-2xl font-bold text-black text-center">
            We'd love to hear from you
          </h3>
          <p className="text-accent font-semibold text-center">
            We have offices and teams all around the world
          </p>
        </div>
        <div className="flex justify-center lg:h-[488px] my-10">
          <img src={map} alt="" />
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10 px-10 py-10">
          {mapsData?.map((data, index) => (
            <div key={index} className="text-center ">
              <h3 className="text-lg font-semibold text-black">
                {data?.title}
              </h3>
              <p className="text-accent text-sm">{data?.text}</p>
              <p className="text-primary font-semibold">{data?.email}</p>
            </div>
          ))}
        </div>
        <div className="text-center flex justify-center flex-col space-y-5 bg-[#F9FAFB] py-10">
          <h3 className="lg:text-3xl text-2xl font-bold text-black">
            Sign up for our newsletter
          </h3>
          <p className="text-sm text-accent">
            Be the first to know about releases and industry news and insight.
          </p>
          <div>
            <div className="flex justify-center items-start gap-2 flex-wrap">
              <div className="flex justify-start items-start flex-col">
                <input
                  type="text"
                  name=""
                  id=""
                  className="px-2 py-1 border border-r-gray-200 rounded-lg text-black focus:outline-primary w-[300px] h-[48px]"
                  placeholder="Enter your email"
                />
                <p className="text-accent text-xs">
                  We care about your data in our{" "}
                  <span className="link">privacy policy</span>
                </p>
              </div>
              <button className="btn  btn-primary text-white h-[48px]">
                Subscribe
              </button>
            </div>
          </div>
        </div>
        <div className="py-10 px-10 ">
          <div className="space-y-4 ">
            <p className="text-primary text-sm font-semibold">Contact us</p>
            <h3 className="text-black lg:text-3xl text-xl font-semibold">
              We'd love to hear from you
            </h3>
            <p className="text-accent text-sm ">
              Our friendly team is always here to chat
            </p>
          </div>
          <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-5 mt-8">
            {contactsData.map((data, index) => (
              <div
                key={index}
                className="h-[250px] flex flex-col justify-between items-start bg-[#E6FEF2] px-5 pt-5 pb-10 "
              >
                <data.icon className="text-4xl bg-primary text-white p-2 rounded-lg" />
                <div>
                  <p className="text-lg font-semibold text-gray-800">
                    {data.title}
                  </p>
                  <p className="text-primary  mb-2">{data.text}</p>
                  <p className="text-primary">{data.email}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Newsletter />
      <Footer />
    </>
  );
};

export default Contact;
